<script lang="ts">
    import {Col } from "sveltestrap"
    import Card from "../UiCommenCard.svelte";
    import Largershadow from "./Largershadow.svelte";
    import Regularshadow from "./Regularshadow.svelte";
    import Smallshadow from "./Smallshadow.svelte";
    import Noshadow from "./Noshadow.svelte";
    import { Examples, ShadowMessage } from "../../../utils/Constant/Constant";
</script>
<Col sm="12">
    <Card cardProps="box-shadow-title" cardHeader2props="pb-0" >
      <div slot="customHeader2">
        <h5>{Examples}</h5>
        <span>{@html ShadowMessage}</span>
      </div>
      <div slot="contentbody" class="row">
        <Largershadow/>
        <Regularshadow/>
        <Smallshadow/>
        <Noshadow/>
      </div>
    </Card>
</Col>